import { useState, useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";
import { useNavigate } from "react-router-dom";

const useFormUploadOtherDocs = () => {
  const { token } = useContext(AuthContext);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e, fileDetails) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const formDataToSend = new FormData();
      fileDetails.forEach((file) => formDataToSend.append(file.name, file.file));

      const res = await fetch(`${process.env.REACT_APP_SERVER_URL}/charterer/profile/upload/otherDocuments`, {
        method: "PUT",
        headers: { Authorization: `Bearer ${token}` },
        body: formDataToSend,
      });

      const resData = await res.json();
      if (!res.ok) throw new Error(resData.message);

      setLoading(false);
      setSuccess("Files uploaded successfully");
      setTimeout(() => {
        setSuccess(null);
        navigate("/charterer_contact_person");
      }, 3000);
    } catch (error) {
      setError(error.message);
      setLoading(false);
    }
  };

  const handleSkip = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_SERVER_URL}/charterer/profile/upload/otherDocuments`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ skipped: true }),
      });

      const resData = await res.json();
      if (!res.ok) throw new Error(resData.message);

      setLoading(false);
      setSuccess("Skipped file upload");
      setTimeout(() => {
        setSuccess(null);
        navigate("/charterer_contact_person");
      }, 3000);
    } catch (error) {
      setError(error.message);
      setLoading(false);
    }
  };

  return {
    handleSubmit,
    handleSkip,
    loading,
    error,
    success,
  };
};

export default useFormUploadOtherDocs;

